export default "__VITE_ASSET__zPwghvt0__"